import { render, staticRenderFns } from "./NewTemplateCandidateContainer.vue?vue&type=template&id=cd5a3912"
import script from "./NewTemplateCandidateContainer.vue?vue&type=script&lang=js"
export * from "./NewTemplateCandidateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports